import ProfilePasswordChange from './profile-password-change';

export default ProfilePasswordChange;
